export const STEP_API_ENDPOINT = process.env.REACT_APP_STEP_API_ENDPOINT;

export interface SWRError extends Error {
  info?: object;
  status?: number;
}

export const swrFetcher = async (...args: Parameters<typeof fetch>) => {
  const res = await fetch(...args);
  // If the status code is not in the range 200-299,
  // we still try to parse and throw it.
  if (!res.ok) {
    const error: SWRError = new Error("An error occurred while fetching the data.");
    // Attach extra info to the error object.
    error.info = await res.json();
    error.status = res.status;
    throw error;
  }

  return res.json();
};
